import styled from "styled-components"
import { colors } from "../../constants"

export const Input = styled.input.attrs((props) => ({
  type: "text"
}))`
  display: block;
  font-size: 14px;
  flex: 1;
  width: ${(props) => (props.width ? props.width : "")};
  border: solid 1px ${(props) => (props.error ? colors.bright_red : colors.very_light_pink)};
  padding: 11px 15px 11px 20px;
  color: ${(props) => props.color || colors.light_black};
  caret-color: ${colors.light_black};
  font-family: Roboto, "Noto Sans SC", "Noto Sans TC", sans-serif !important;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  -khtml-border-radius: 0;

  margin: 0;

  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;

  background-color: ${colors.white};
  &:disabled {
    background-color: rgba(207, 207, 207, 0.5);
  }
  // &:read-only {
  //   cursor: pointer;
  // }

  :focus {
    border-color: ${colors.blood_orange};
    outline: 0;
    -webkit-box-shadow:
      inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(251, 80, 4, 0.6);
    box-shadow:
      inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(251, 80, 4, 0.6);
  }

  ::placeholder {
    color: ${(props) => props.placeholderColor || colors.brown_grey};
    font-family: Roboto, "Noto Sans SC", "Noto Sans TC", sans-serif !important;
  }

  ::-webkit-input-placeholder {
    color: ${(props) => props.placeholderColor || colors.brown_grey};
    font-family: Roboto, "Noto Sans SC", "Noto Sans TC", sans-serif !important;
  }

  ::-moz-placeholder {
    color: ${(props) => props.placeholderColor || colors.brown_grey};
    font-family: Roboto, "Noto Sans SC", "Noto Sans TC", sans-serif !important;
  }
`
